import React from 'react'

const SettingsProfile = () => {
    return (
        <div className="_nft_settings_profile_wrap">
            <div className="_nft_settings_profile_info">
                <div className="_nft_settings_profile_info_img">
                    <img src="assets/img/profile-img.png" alt="bg" className="_nft_settings_profile_info_img_tag" />
                    <span className="_nft_settings_profile_info_mini_img">
                        <svg xmlns="http://www.w3.org/2000/svg" width={21} height={17} fill="none" viewBox="0 0 21 17">
                            <path fill="#35373E" d="M6.048 9.97a4.038 4.038 0 0 0 4.037 4.037 4.038 4.038 0 0 0 4.037-4.037 4.036 4.036 0 1 0-8.073 0ZM18.78 3.139h-4.347c-.31-1.242-.62-2.484-1.863-2.484H7.601c-1.242 0-1.553 1.242-1.863 2.484H1.39c-.683 0-1.242.559-1.242 1.242v11.178c0 .683.559 1.242 1.242 1.242h17.388c.683 0 1.242-.559 1.242-1.242V4.381c0-.683-.559-1.242-1.242-1.242Zm-8.694 12.343a5.513 5.513 0 0 1 0-11.024 5.513 5.513 0 0 1 0 11.024Zm8.694-8.617h-2.484V5.623h2.484v1.242Z" />
                        </svg>
                    </span>
                </div>
                <div className="_nft_settings_profile_info_cont">
                    <h3 className="_nft_settings_profile_info_cont01">Profile</h3>
                    <p className="_nft_settings_profile_info_cont02">Update your photo and personal Details</p>
                </div>
            </div>
            <div className="_nft_settings_profile_btns">
                <div className="_nft_settings_profile_btn1">
                    <button className="_nft_settings_profile_cancel_btn">
                        Cancel
                    </button>
                </div>
                <div className="_nft_settings_profile_btn2">
                    <button className="_nft_settings_profile_save_btn">
                        Save
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SettingsProfile